module.exports = __webpack_public_path__ + "img/item-3.6daf3070.svg";